import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { VideoMain, VideoOverlay } from './index.style'
import useAttract from '@hooks/useAttract'
import Modal from '@components/Modal'
import { GatsbyImage } from 'gatsby-plugin-image'
import PlayButton from '@components/PlayButton'
import VideoModal from '@components/VideoModal'
import { setMousePosition } from '@Store/'
import { useStore } from '@Store/'

const Video = ({ content, showOverlay = true, hasOverlay, grid, ...props }) => {
  const [, dispatch] = useStore()
  const [playing, setPlaying] = useState(false)
  const { $attractTarget, setAttractFieldRefs } = useAttract({
    contain: true,
  })
  const overlayImage = content.coverImage

  const stopVideo = () => setPlaying(false)

  return (
    <VideoMain
      ref={setAttractFieldRefs}
      hasOverlay={hasOverlay}
      grid={grid}
      onMouseMove={e => {
        setMousePosition(dispatch, [e.clientX, e.clientY])
      }}
      onMouseLeave={e => {
        setMousePosition(dispatch, [0, 0])
      }}
      {...props}
    >
      {showOverlay && (
        <>
          <VideoOverlay
            aria-label="Play video"
            playing={playing}
            onClick={() => setPlaying(true)}
            hasOverlay={hasOverlay}
            grid={grid}
          >
            {overlayImage && (
              <GatsbyImage
                image={overlayImage.gatsbyImageData}
                alt={overlayImage.description}
              />
            )}
          </VideoOverlay>

          <PlayButton ref={$attractTarget} text="Play" show={!playing} videoId={content.videoId} type={content.__typename} />
        </>
      )}

      <Modal isOpen={playing} onDismiss={stopVideo} ariaLabel="Video player">
        <VideoModal
          type={content.__typename}
          data={content}
          onClose={stopVideo}
        />
      </Modal>
    </VideoMain>
  )
}

Video.propTypes = {
  content: PropTypes.object,
  animation: PropTypes.object,
}

export default Video
